// extracted by mini-css-extract-plugin
export default {"filter-column-height":"SummaryFilterBox_filter-column-height__tEG59","ipad-pro-filterbox":"SummaryFilterBox_ipad-pro-filterbox__IxfXP"};